<template>
    <div class="form-consult" v-if="form != null" :class="{'open' : openFormConsult}">
        <div class="quality-form-title">
            <h2>{{form.form_consult_title}}</h2>
            <a href="#" @click.prevent="closeForm" class="close-form-link">
                <svg-icon icon-class="close" className="share-icon icon-close"/>
            </a>
        </div>
        <form class="form_call">
            <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                <div class="form-group form-text">
                    <label for="name">{{form.name_label}}</label>
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <label for="phone">{{form.phone_label}}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="form-group form-mail">
                    <label for="email">{{form.email_label}}</label>
                    <input type="text" name="email" class="form-control"  :placeholder="form.email_mask" v-model="mail" v-validate="{rules: { required: true, regex: regexRules.mail }}"  data-vv-delay="1000">
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_call_btn_desc}}</button>
                    <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email')">Заполните все поля</span>
                </div>
            </div>
            <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо! Ваша заявка отправлена.</h3>
            </div>
        </form>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    const dict = {
        custom: {
            email: {
                required: () => 'Введите ваш E-mail'
            },
            name: {
                required: () => 'Введите ваше имя'
            },
            phone: {
                required: () => 'Введите ваш номер телефона'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'FormConsult',
        data () {
            return {
                phone: '',
                name: '',
                mail: '',
                quest: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
        },
        computed: mapGetters({
            form: 'loadForms',
            openFormConsult: 'loadOpenFormConsult',
            formData: 'loadFormConsultData',
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var data = {
                    'admin': this.form.email_admin,
                    'name': this.name,
                    'phone': this.phone,
                    'mail': this.mail,
                    'city': this.formData.city,
                    'page': this.formData.page,
                    'page_key': this.formData.page_key,
                };
                console.log(data, 'form consult')
                // console.log(JSON.stringify(data));
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        axios.post('/formSendConsult.php', querystring.stringify(data));
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLSdXCxcAiH63F3BPqltmqVOjnaZW1dBq00gcEuUtEu8gazhVKQ/formResponse",
                            data: {
                                // name
                                "entry.869427723": this.name,
                                // phone
                                "entry.1947750122": this.phone,
                                // email
                                "entry.796094339": this.mail,
                                // city
                                "entry.993147044": this.formData.city,
                                // page
                                "entry.39752680": this.formData.page,
                                // page_key
                                "entry.107783577": this.formData.page_key,
                            },
                            type: "POST",
                            dataType: "xml"
                        });
                        setTimeout(() => {
                            this.closeForm();
                        }, 1500);
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
            closeForm() {
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                this.phone = '';
                this.name = '';
                this.mail = '';
                setTimeout(() => {
                    this.formVisible = true;
                }, 1000);
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-consult.scss';
    @import '@/styles/respond/forms/form-consult-respond.scss';
</style>